/**
 * Marketing-site config. Written to make a clean split to
 *   clientdeskva.com          (this marketing site)
 *   app.clientdeskva.com      (the existing application)
 * trivial later — every internal reference is either a relative path
 * (React Router) or resolved through this file.
 */
const env = typeof process !== "undefined" ? (process.env || {}) : {};

// Fallback to the current origin so the site works today on the shared preview host.
const currentOrigin =
  typeof window !== "undefined" && window.location ? window.location.origin : "";

// Read process.env.REACT_APP_* directly: CRA inlines these at build time, whereas
// `typeof process` is "undefined" in the browser (webpack 5), which made `env` empty.
export const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || env.REACT_APP_MARKETING_URL || currentOrigin;
export const APP_URL = process.env.REACT_APP_APP_URL || env.REACT_APP_APP_URL || currentOrigin;

export const SIGN_IN_URL = `${APP_URL}/login`;
export const SIGN_UP_URL = `${APP_URL}/signup`;

export const SUPPORT_EMAIL = "support@clientdeskva.com";
export const PRIVACY_EMAIL = "privacy@clientdeskva.com";

export const APP_STORE_URL = "https://apps.apple.com/app/id6804363702";

export const CANONICAL_HOST = "https://clientdeskva.com";
